import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SideBar',{attrs:{"bar_name":_vm.tabName,"user":_vm.user}}),_c(VMain,[_c(VContainer,[_c('AgentLine',_vm._b({},'AgentLine',{ user: _vm.user, tabName: _vm.tabName },false))],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }